module.exports = __webpack_public_path__ + "img/billing.c6b949d1.svg";